import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { SeoEffects } from './store';
import { seoReducers } from './store/seo.reducers';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
        StoreModule.forFeature('seo', seoReducers),
        EffectsModule.forFeature([SeoEffects]),
    ],
    providers: [],
    exports: [],
})
export class SeoModule {}
